import styled from '@emotion/styled';

export type CardVariant = 'list' | 'grid' | 'mobile';

const CARD_BG = '#003A42';
const CTA_COLOR = '#14C17B';

export const GridCardWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(1.5)} 0;
`;

export const CardRoot = styled.div<{ variant: CardVariant }>`
  position: relative;
  background: ${CARD_BG};
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;

  ${({ variant }) => variant === 'list' && `
    width: 100%;
    height: 150px;
  `}

  ${({ variant }) => variant === 'grid' && `
    width: 100%;
    height: 450px;
  `}

  ${({ variant }) => variant === 'mobile' && `
    width: 100%;
    padding-bottom: ${32}px;
    box-shadow: 0 2px 20px rgba(0,0,0,0.05), 0 2px 5px rgba(0,0,0,0.06);
  `}
`;

export const CardPhoto = styled.img<{ variant: CardVariant }>`
  display: block;
  object-fit: cover;

  ${({ variant }) => variant === 'list' && `
    position: absolute;
    top: 0;
    right: 0;
    width: 268px;
    height: 100%;
  `}

  ${({ variant }) => variant !== 'list' && `
    width: 100%;
    height: ${variant === 'mobile' ? 200 : 195}px;
  `}
`;

export const ListGradient = styled.div`
  position: absolute;
  top: 0;
  right: 134px;
  width: 134px;
  height: 100%;
  background: linear-gradient(to right, ${CARD_BG}, rgba(0, 58, 66, 0));
  pointer-events: none;
`;

export const VerticalGradient = styled.div<{ variant: CardVariant }>`
  position: absolute;
  top: ${({ variant }) => variant === 'mobile' ? 100 : 97}px;
  left: 0;
  right: 0;
  height: 100px;
  background: linear-gradient(to bottom, transparent, ${CARD_BG});
  pointer-events: none;
`;

export const DeveloperAvatar = styled.img<{ variant: CardVariant }>`
  position: absolute;
  object-fit: cover;

  ${({ variant }) => variant === 'list' && `
    top: 8px;
    right: 8px;
    width: 48px;
    height: 48px;
    border-radius: 0 12px 0 12px;
  `}

  ${({ variant }) => variant !== 'list' && `
    top: 8px;
    left: 8px;
    width: 56px;
    height: 56px;
    border-radius: 12px 0 12px 0;
  `}
`;

export const InsetBorder = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  bottom: 8px;
  left: 8px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  border-radius: 12px;
  pointer-events: none;
`;

export const ListContent = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 30%;
  left: 230px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: right;
`;

export const VerticalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
  padding: ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(3)} 0;
  text-align: center;
`;

export const CardTitle = styled.p<{ variant: CardVariant }>`
  color: #fff;
  font-weight: bold;
  margin: 0;
  font-size: ${({ variant }) => variant === 'mobile' ? 25 : 21}px;
  line-height: ${({ variant }) => variant === 'mobile' ? 32 : 32}px;
`;

export const CardLocation = styled.p`
  color: #fff;
  font-weight: normal;
  font-size: 13px;
  line-height: 20px;
  margin: 0;
`;

export const CardDetails = styled.p`
  color: #fff;
  font-weight: normal;
  font-size: 15px;
  line-height: 24px;
  margin: 0;
`;

export const CardDetailsPriceSegment = styled.span`
  white-space: nowrap;
`;

export const CtaButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${CTA_COLOR};
  border: none;
  border-radius: 100px;
  width: 170px;
  height: 48px;
  cursor: pointer;
  color: #fff;
  font-weight: bold;
  font-size: 15px;
  line-height: 20px;
  white-space: nowrap;
  padding: 0 ${({ theme }) => theme.spacing(2)};
`;

export const ListCtaContainer = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: ${({ theme }) => theme.spacing(5)};
`;

export const VerticalCtaContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing(2)};
`;
